module.exports = __webpack_public_path__ + "img/punch.b8b9a18e.png";